import { ToggleTabs as Tabs, assets } from '@round/whitelabel-ui';
import { useState } from 'react';
import ReportTiktokCampaigns from '../../Campaigns/TiktokCampaigns/ReportTiktokCampaigns';
import TikTokPlatformPosts from './TikTokPlatformPosts';
import styles from './TikTokTab.module.css';
import { PostUrlClipboardButton } from 'Modules/Plans/CopyToClipboard/PostUrlTable';
import { useCopyReportCampaignPostUrls } from '../../hooks/useCopyReportCampaignPostUrls';
import useCampaigns from '../../Campaigns/useCampaigns';

const { RowVertical: RowVerticalIcon, TiktokSolid: TikTokSolidIcon } = assets;

const TikTokTab = () => {
    const { campaignsData } = useCampaigns('tiktok');

    const [activeTab, setActiveTab] = useState<'campaigns' | 'posts'>('campaigns');

    const { isLoading: isCopyingPostUrls, copyReportCampaignPostUrls } = useCopyReportCampaignPostUrls(
        'tiktok',
        campaignsData.data?.results ?? []
    );

    return (
        <Tabs activeTab={activeTab} onChange={setActiveTab}>
            <div className={styles.header}>
                <Tabs.Menu>
                    <Tabs.Item name="campaigns" tooltip="View campaigns">
                        <RowVerticalIcon />
                    </Tabs.Item>
                    <Tabs.Item name="posts" tooltip="View posts">
                        <TikTokSolidIcon />
                    </Tabs.Item>
                </Tabs.Menu>

                {activeTab === 'campaigns' && (
                    <PostUrlClipboardButton
                        className={styles.copyPostUrlsButton}
                        onClick={copyReportCampaignPostUrls}
                        disabled={!campaignsData.data?.results?.length}
                        isLoading={isCopyingPostUrls}
                    />
                )}
            </div>

            <Tabs.Panel name="campaigns">
                <ReportTiktokCampaigns />
            </Tabs.Panel>

            <Tabs.Panel name="posts" className={styles.postsTab}>
                <TikTokPlatformPosts />
            </Tabs.Panel>
        </Tabs>
    );
};

export default TikTokTab;
